/* eslint-disable import/prefer-default-export */
export function split(string) {
  return string.split('')
}